import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Organisation } from "../../models/organisation"

@Injectable({
  providedIn: "root",
})
export class OrganisationDisplayDataResolver
  implements DisplayDataResolver<Organisation>
{
  typeDisplayName = "Organisation"

  constructor() {}

  getIcon(entity: Organisation): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Organisation): string | undefined {
    return undefined
  }

  getSubTitle(entity: Organisation): string | undefined {
    return undefined
  }

  getTitle(entity: Organisation): string {
    return entity.name
  }

  getShortTitle(entity: Organisation): string {
    return entity.id
  }

  getItemHref(entityOrID: Organisation | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/organisation"
    }
    if (typeof entityOrID === "string") return "/app/organisation/" + entityOrID
    return "/app/organisation/" + entityOrID.id
  }
}
